<template>
  <div class="announcement-bar">
    <div class="announcement-content">
      <div class="announcement-container">
        <div class="user-info" v-if="user">
          <span class="nickname">Hi，亲爱的 {{ user.nick }}</span>
          <div class="logout-container">
            <button v-if="canAccessSettings" class="settings-btn" @click="goToSettings">系统设置</button>
            <button class="logout-btn" @click="logout">退出</button>
          </div>
        </div>
        <div @click="goToHome" class="version-container">
          {{ latestAnnouncement.version }}
        </div>
        <el-button class="nav-btn" type="primary" @click="goToHome">首页</el-button>
        <div class="announcement-content" @click="showAllAnnouncements">
          <div class="announcement-title">{{ latestAnnouncement.title }}</div>
          <div class="announcement-desc">{{ latestAnnouncement.content }}</div>
        </div>
      </div>
    </div>

    <div v-if="showModal" class="modal" @click.self="closeModal">
      <div class="modal-content">
        <div class="modal-header">
          <h3>公告详情</h3>
          <button @click="closeModal" class="close-btn">×</button>
        </div>
        <div class="modal-body">
          <div class="history-list">
            <div v-for="(item, index) in announcements" :key="index" class="history-item">
              <div class="history-version">{{ item.version }}</div>
              <div class="history-content">
                <div class="history-title">{{ item.title }}</div>
                <div class="history-desc">{{ item.content }}</div>
                <div class="history-date">{{ item.date }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { announcements } from '@/mock/announcements.js'
import http from '@/utils/http'

export default {
  name: 'AnnouncementBar',
  data() {
    return {
      user: JSON.parse(localStorage.getItem('auth-user') || 'null'),
      announcements: announcements,
      showModal: false,
      currentAnnouncement: null,
      canAccessSettings: false
    }
  },
  computed: {
    latestAnnouncement() {
      return this.announcements[0]
    }
  },
  async mounted() {
    await this.checkSettingsPermission()
  },
  methods: {
    async checkSettingsPermission() {
      try {
        const settingUserList = await http.getDictByCode('setting_user_list')
        console.log('settingUserList:', settingUserList)
        console.log('current user:', this.user)
        
        if (settingUserList && Array.isArray(settingUserList)) {
          // 尝试多个可能的用户名字段
          const username = this.user?.username || this.user?.loginName || this.user?.nick || this.user?.userName || ''
          console.log('checking username:', username)
          console.log('settingUserList array:', settingUserList)
          console.log('is in list:', settingUserList.includes(username))
          
          this.canAccessSettings = settingUserList.includes(username)
          console.log('canAccessSettings:', this.canAccessSettings)
        } else {
          console.log('settingUserList is not an array or is null')
        }
      } catch (error) {
        console.error('检查设置权限失败:', error)
        this.canAccessSettings = false
      }
    },
    goToSettings() {
      this.$router.push('/system-settings')
    },
    logout() {
      localStorage.removeItem('auth-token')
      localStorage.removeItem('auth-user')
      this.$router.push('/login')
    },
    showAllAnnouncements() {
      this.showModal = true
      document.addEventListener('keydown', this.handleKeyDown)
    },
    closeModal() {
      this.showModal = false
      document.removeEventListener('keydown', this.handleKeyDown)
    },
    handleKeyDown(e) {
      if (e.key === 'Escape') {
        this.closeModal()
      }
    },
    beforeUnmount() {
      document.removeEventListener('keydown', this.handleKeyDown)
    }
  }
}
</script>

<script setup>
import { useRouter } from 'vue-router'

const router = useRouter()

const goToHome = () => {
  // 跳转方式一：根据 path
  router.push('/')

  // 跳转方式二：根据 name
  // router.push({ name: 'tools-translate-template' })
}
</script>

<style scoped>
.announcement-bar {
  width: 100%;
  height: 100%;
  background-color: #f8f8f8;
  border-bottom: 1px solid #e7e7e7;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.user-info {
  position: absolute;
  right: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  overflow: visible;
  padding-bottom: 5px;
}

.nickname {
  color: #1890ff;
  font-weight: bold;
  cursor: pointer;
  padding: 5px 20px;
  font-size: 14px;
  margin-right: 30px;
  position: relative;
  z-index: 1;
}

.logout-container {
  width: 100%;
  max-height: 0;
  transition: max-height 0.3s ease-out;
  overflow: hidden;
  position: absolute;
  top: 100%;
  display: flex;
  flex-direction: column;
}

.user-info:hover .logout-container,
.logout-container:hover {
  max-height: 80px;
}

.settings-btn {
  background: #67c23a;
  color: white;
  border: none;
  padding: 5px 20px;
  cursor: pointer;
  font-size: 14px;
  width: 100%;
  text-align: center;
  box-sizing: border-box;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.settings-btn:hover {
  background: #5daf34;
}

.logout-btn {
  background: #4c68f0;
  color: white;
  border: none;
  padding: 5px 20px;
  border-radius: 0 0 4px 4px;
  cursor: pointer;
  font-size: 14px;
  width: 100%;
  text-align: center;
  box-sizing: border-box;
}

.logout-btn:hover {
  background: #3a56d4;
}

.announcement-container {
  display: flex;
  width: 100%;
  max-width: 100%;
  padding: 10px 20px;
  align-items: center;
  margin: 0 auto;
}

.version-container {
  font-weight: bold;
  color: #1890ff;
  width: 100px;
  flex-shrink: 0;
  font-size: 16px;
  padding-right: 15px;
}

.version-container:hover {
  color: #0270d7;
}

.announcement-content {
  flex: 1;
  cursor: pointer;
  padding-left: 15px;
  padding-right: 20px;
  overflow: hidden;
}

.announcement-title {
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.announcement-desc {
  font-size: 12px;
  color: #666;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  padding-right: 80px;
}

.announcement-desc::after {
  content: "查看详情";
  position: absolute;
  right: 10;
  top: 0;
  background: #1890ff;
  color: white;
  padding: 0 8px;
  border-radius: 4px;
  font-size: 12px;
}

.announcement-detail {
  width: 100%;
  padding: 10px;
}

.detail-row {
  margin-bottom: 10px;
  display: flex;
}

.detail-label {
  font-weight: bold;
  min-width: 60px;
}

.detail-value {
  flex: 1;
  word-break: break-word;
  overflow-wrap: break-word;
  max-width: 400px;
  padding-right: 10px;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background-color: white;
  padding: 20px;
  border-radius: 4px;
  max-width: 500px;
  width: 80%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.close-btn {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
}

.modal-body {
  max-height: 60vh;
  overflow-y: auto;
  padding: 10px;
}

.history-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.history-item {
  display: flex;
  gap: 15px;
  padding: 10px;
  border-bottom: 1px solid #eee;
}

.history-version {
  font-weight: bold;
  color: #1890ff;
  width: 80px;
  flex-shrink: 0;
}

.history-content {
  flex: 1;
}

.history-title {
  font-weight: bold;
  margin-bottom: 5px;
  text-align: center;
}

.history-desc {
  color: #666;
  font-size: 14px;
  margin-bottom: 5px;
  white-space: pre-wrap;
  word-break: break-word;
  text-align: left;
}

.history-date {
  color: #999;
  font-size: 12px;
  text-align: right;
}

.nav-btn {
  font-size: 16px;
  font-weight: 500;
  padding: 0 20px;
  height: 50px;
  border-radius: 0;
  /* 去掉圆角，更像导航 */
  border: none;
  /* 去掉边框 */
  background: transparent;
  /* 默认透明背景 */
  color: #409eff;
  /* 默认字体颜色 */
}

.nav-btn:hover {
  background: rgba(64, 158, 255, 0.1);
  /* hover 时淡蓝背景 */
  color: #0579ee;
  /* hover 字体高亮 */
}
</style>
